import React, { Component } from 'react';
import { screenTypes } from '../../../Constants/screenTypes';

const screenWidthProvider = WrappedComponent => {
    return class HOC extends Component {
        state = {
            screen: screenTypes.DESKTOP,
        };

        detectScreenType = () => {
            const screenWidth = window.innerWidth;

            switch (true) {
                case screenWidth <= 767:
                    return screenTypes.MOBILE;
                case screenWidth <= 1025:
                    return screenTypes.TABLET;
                default:
                    return screenTypes.DESKTOP;
            }
        };

        handleWindowResize = () => {
            const { screen } = this.state;
            let screenVersion = this.detectScreenType();

            if (screenVersion !== screen) this.setState({ screen: screenVersion });
        };

        componentDidMount() {
            let screen = this.detectScreenType();
            this.setState({ screen });

            window.addEventListener('resize', this.handleWindowResize);
        }

        componentWillUnmount() {
            window.removeEventListener('resize', this.handleWindowResize);
        }

        render() {
            const { screen } = this.state;
            return <WrappedComponent {...this.props} screenWidth={screen} />;
        }
    };
};

export default screenWidthProvider;



// WEBPACK FOOTER //
// ./src/UI/Containers/HOCS/ScreenWidthProvider.js